export default "__VITE_ASSET__Mos3a9s6__"